const whatsappTypes = {
    GET_CHANNELS_PENDING: "GET_CHANNELS_PENDING",
    GET_CHANNELS_SUCCESS: "GET_CHANNELS_SUCCESS",
    GET_CHANNELS_ERROR: "GET_CHANNELS_ERROR",

    PUT_ROUTING_PENDING: "PUT_ROUTING_PENDING",
    PUT_ROUTING_SUCCESS: "PUT_ROUTING_SUCCESS",
    PUT_ROUTING_ERROR: "PUT_ROUTING_ERROR",

    CONNECT_CHANNEL_PENDING: "CONNECT_CHANNEL_PENDING",
    CONNECT_CHANNEL_SUCCESS: "CONNECT_CHANNEL_SUCCESS",
    CONNECT_CHANNEL_ERROR: "CONNECT_CHANNEL_ERROR",

    DISCONNECT_CHANNEL_PENDING: "DISCONNECT_CHANNEL_PENDING",
    DISCONNECT_CHANNEL_SUCCESS: "DISCONNECT_CHANNEL_SUCCESS",
    DISCONNECT_CHANNEL_ERROR: "DISCONNECT_CHANNEL_ERROR",
};

export default whatsappTypes;
